import { Component, ViewChild, OnInit, ElementRef, AfterViewInit, AfterViewChecked } from '@angular/core';
import { Router } from '@angular/router';
import { TicketService } from 'src/app/services/ticket.service';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { finalize, take } from 'rxjs/operators';


declare var bootstrap: any;

@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.scss']
})
export class TicketsComponent implements OnInit {
  tickets: any[] = [];
  newTicket = { subject: '', message: '' };
  isLoading: boolean = false
  modalName: string = 'createTicketModal';
  subjectError: string = '';
  messageError: string = '';
  subjectTouched: boolean = false; // Tracks if the subject field was touched
  messageTouched: boolean = false; // Tracks if the message field was touched
  selectedTicket: any = null;
  ticketMessages: any[] = [];
  groupedMessages: any[] = [];
  isTicketLoading = false;
  isChatEmpty: boolean = true;
  isUserAtBottom: boolean = true;
  isUserScrolling: boolean = false;
  refreshInterval: any = null; // Holds the interval instance
  pollingRate: number = 5000;  // Refresh every 5 seconds (adjust as needed)
  isChatOpen: boolean = false;
  isDesktop: boolean = window.innerWidth > 768; // Detect desktop on load


    @ViewChild('ticketForm') ticketForm!: NgForm;
  
  constructor(private ticketService: TicketService, private router: Router, private toastrService: ToastrService) {}

  ngOnInit(): void {
    this.fetchTickets();
  }

  fetchTickets(): void {
    this.isLoading = true;
    this.ticketService.getAll()
      .pipe(
        take(1),
        finalize(() => (this.isLoading = false)) // Ensure `isLoading` stops after API
      )
      .subscribe(
        response => {
          this.tickets = response.data;
        },
        error => {
          console.error('❌ Error fetching tickets:', error);
        }
      );
  }
  
  openTicket(ticketId: number): void {
    this.router.navigate(['/help/message', ticketId]); // ✅ Redirect to `MessegeComponent`
  }

  submitNewTicket(form: NgForm): void {
    if (!form.valid || this.subjectError || this.messageError) {
      return; // Prevent submission if fields are invalid
    }

    this.isLoading = true;

    this.ticketService.post(this.newTicket)
      .pipe(take(1), finalize(() => (this.isLoading = false)))
      .subscribe(
        res => {
          if (res.status === 200) {
           // this.toastrService.success("✅ تم إنشاء التذكرة بنجاح!");
            this.fetchTickets(); // Refresh ticket list
            form.resetForm(); // Clear form
            this.subjectTouched = false; // Reset field tracking
            this.messageTouched = false;
            this.changeStatusToClosed('createTicketModal'); // Close modal
          }
        },
        error => {
          console.error('❌ Error creating ticket:', error);
          this.toastrService.error("❌ حدث خطأ أثناء إرسال التذكرة!");
        }
      );
  }

  changeStatusToClosed(modalId: string): void {
    const modal = document.getElementById(modalId);
    if (modal) {
      const bsModal = bootstrap.Modal.getInstance(modal);
      bsModal?.hide();
    }
  }
  
  validateSubject(): void {
    if (this.newTicket.subject.length < 5) {
      this.subjectError = "يجب أن يحتوي الموضوع على 5 أحرف على الأقل.";
    } else {
      this.subjectError = ""; // Clear error when valid
    }
  }

  validateMessage(): void {
    if (this.newTicket.message.length < 10) {
      this.messageError = "يجب أن تحتوي الرسالة على 10 أحرف على الأقل.";
    } else {
      this.messageError = ""; // Clear error when valid
    }
  }


}
